<template>
  <div class="page-home">
      <img class="logo" src="/img/logo-negative.png">
      <router-link class="btn btn-outline-secondary" :to="{ name: 'scanner' }">Scan</router-link>
      <div class="alert fixed-bottom text-center">
        <span v-if="account_name">{{ account_name }} · {{ device_name }} · </span>v. <span v-html="version"></span>
      </div>
  </div>
</template>
<style lang="scss" scoped>
  .page-home{
    min-height: 100%;
    background:#dfde16;
    display: flex;
    align-items: center;
    justify-content:center;
    background-image: linear-gradient(30deg,hsla(0,0%,100%,.6),rgba(0,0,0,.1));
    flex-direction: column;

    .logo{
      width: 300px;
      max-width: 90%;
      margin: 10vh 0;
    }
  }
</style>
<script type="text/javascript">
  import kiosk from './../classes/kiosk'

  export default {
    data: function(){
      return {
        version: 0,
        account_name: null,
        device_name: null
      }
    },
    mounted: function(){
      this.version = this.$helper.version;
      kiosk.pairing().then(pairing => {
        if (pairing) {
          this.account_name = pairing.account_name;
          this.device_name = pairing.device_name;
        }
      });
    }
  };
</script>
